
<div  *ngIf="isLoading" class="loader-display nav-loader">
    <!-- <img  src="assets/img/loader.gif" alt=""> -->

    <p-progressSpinner></p-progressSpinner>
    <h5>Please Wait...</h5>

</div>
